export default function init(element) {
    window.addEventListener('scroll', function () {
        if (window.scrollY > 600) {
            element.classList.add('!right-0');
        } else {
            element.classList.remove('!right-0');
        }
    });
}